import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from '../../common/services/breadcrumb';

@Component({
  selector: 'common-layout',
  templateUrl: './common-layout.component.html',
  styleUrl: './common-layout.component.scss'
})
export class CommonLayoutComponent {

  private breadcrumbSubscription: Subscription;
  breadcrumbs: { label: string, link: string, skip?: boolean }[] = [];
  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbSubscription = this.breadcrumbService.breadcrumbs$.subscribe(breadcrumbs => {
      this.breadcrumbs = breadcrumbs;
    });
  }
  ngOnDestroy() {
    this.breadcrumbSubscription.unsubscribe();
  }
}
